<template>
  <form @submit.stop.prevent="submit" class="btns-relatorios">
    <div class="col-md-7" style="display: flex;">
      <div class="col-md-6 m-r-md">
        <label for="data-inicio">Data Início</label>
        <div>
          <input class="form-control input-sm" id="data-inicio" required v-model="pesquisar.inicio" v-mask="'##/##/####'"/>
        </div>
      </div>

      <div class="col-md-6">
        <label for="data-fim">Data Final</label>
        <div>
          <input class="form-control input-sm" id="data-fim" required v-model="pesquisar.final" v-mask="'##/##/####'"/>
        </div>
      </div>
    </div>

    <button type="submit"
            class="btn-relatorios"
            @click="submit">
      <i class="fa fa-file m-r-sm"></i> Gerar relatório
    </button>
  </form>
</template>

<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import date from '../../../utils/date'

  export default {
    name: 'BtnRelatorios',
    directives: {mask},
    data () {
      return {
        pesquisar: {
          inicio: date.formatDate(new Date(), 'DD/MM/YYYY'),
          final: date.formatDate(new Date(), 'DD/MM/YYYY')
        }
      }
    },
    methods: {
      submit () {
        this.$emit('buscaRelatorio', this.pesquisar)
      }
    }
  }
</script>

<style scoped>
  .btns-relatorios {
    max-width: 800px;
    width: 100%;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
  }

  .btn-relatorios {
    background-color: #FFFFFF;
    color: #333333;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, .03), 0 16px 24px 2px rgba(0, 0, 0, .02), 0 6px 30px 5px rgba(0, 0, 0, .04);
  }
</style>



// WEBPACK FOOTER //
// BtnRelatorios.vue?03818736